import { liveavatar_url } from "./base_urls";

export const CREATE_LIVEAVATAR_SESSION_TOKEN =
  liveavatar_url + "v1/sessions/token";

/** @deprecated Use LiveAvatar SDK session.stop() */
export const STOP_LIVEAVATAR_SESSION = liveavatar_url + "v1/sessions/stop";
